import { ReactComponent as FlagIcon } from "./svg/do-flag.svg";
import "../flag-icon.scss";

export const DOFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
